export const SYNC_ZWAVE_CHANNEL = '@@myDevices/zwaveChannelSync'
export const SYNC_ZWAVE_CHANNEL_SENT = '@@myDevices/zwaveChannelSyncSent'
export const OPEN_ZWAVE_CHANNEL = '@@myDevices/zwaveChannelOpen'
export const CLOSE_ZWAVE_CHANNEL = '@@myDevices/zwaveChannelClose'
export const SET_RESPONSE_FROM_ZWAVE_CHANNEL = '@@myDevices/setResponseFromZwaveChannel'
